import axios from 'axios'
import { useContext, useMemo } from 'react'

import AccessTokenContext from 'src/context/accessTokenContext'
import OrganizationContext from 'src/context/organizationContext'
import SimulationCtx from 'src/context/simulationCtx'
import { APP_ENV } from 'src/env'

export function useOrnaBackendClient() {
    const { accessToken } = useContext(AccessTokenContext)
    const { organizationId } = useContext(OrganizationContext)
    const simulationCtxData = useContext(SimulationCtx)

    const { isSimulationEnabled, simulationId } = useMemo(() => {
        if (!simulationCtxData) {
            return { isSimulationEnabled: false, simulationId: null }
        }

        const { isEnabled: isSimulationEnabled, simulationId } =
            simulationCtxData

        return { isSimulationEnabled, simulationId }
    }, [simulationCtxData])

    const client = useMemo(() => {
        return axios.create({
            baseURL: `${APP_ENV.REACT_APP_ORNA_BACKEND_URL}`,
            headers: {
                ...(accessToken &&
                    APP_ENV.REACT_APP_STAGE !== 'cypress' && {
                        Authorization: `Bearer ${accessToken}`,
                    }),
                ...(organizationId &&
                    APP_ENV.REACT_APP_STAGE !== 'cypress' && {
                        'X-User-Org': organizationId,
                    }),
                ...(APP_ENV.REACT_APP_STAGE === 'cypress' && {
                    'x-cypress-testing': APP_ENV.REACT_APP_CYPRESS_KEY,
                }),
                ...(isSimulationEnabled && {
                    // -------
                    // NOTE: Not using a boolean here because it crashes the WS Link
                    // when simulation mode is enabled
                    'x-simulation-enabled': 'true',
                    // -------
                    'x-simulation-id': simulationId,
                }),
            },
        })
    }, [accessToken, isSimulationEnabled, organizationId, simulationId])

    return client
}
